var window=global;var $CLJS=require("./cljs_env.js");
'use strict';$CLJS.At=require("ttag");module.exports=$CLJS.At;